<template>
  <div
    class="flex items-center border rounded-lg p-2 shadow-sm gap-4 cursor-pointer"
    @click="handleClick"
  >
    <!-- Image Section -->
    <div class="flex-shrink-0 w-12 h-12">
      <img
        :src="thumbnail"
        alt="thumbnail"
        class="w-full h-full object-cover rounded-sm"
      />
    </div>

    <!-- Title Section -->
    <div class="flex-grow">
      <h3 class="font-semibold text-sm md:text-base">
        {{ title }}
      </h3>
    </div>

    <!-- Status Section -->
    <div class="flex-shrink-0">
      <Tag
        :severity="
          Helper.getQCProgressStatusColor(
            Constants.enums.PROGRESS_STATUS.IN_PROGRESS
          )
        "
        :value="`${status}`"
        class="text-xs md:text-sm"
      />
    </div>
  </div>
  <FormPageDialogComponent
    :visible="dialogVisible"
    :page="pageData"
    :title="title"
    @update:visible="dialogVisible = $event"
  />
  <FullScreenOverlayLoader
    :isLoading="loaderObj.isLoading"
    :message="loaderObj.loaderMsg"
  />
  <ErrorDialog
    :visible="errorObj.isVisible"
    :message="errorObj.errorMsg"
    :onConfirm="onErrorDialogClose"
    @update:visible="errorObj.isVisible = $event"
  />
</template>

<script>
  import { defineComponent, ref } from "vue";
  import Helper from "@/utils/helper";
  import Constants from "@/utils/constants";
  import FormPageDialogComponent from "./FormPageDialogComponent.vue";
  import FullScreenOverlayLoader from "@/components/FullScreenOverlayLoader.vue";
  import ErrorDialog from "@/components/ErrorDialog.vue";
  import { useFormPageStore } from "@/stores/formPageStore";

  export default defineComponent({
    name: "QCSummaryTemplateComponent",
    components: {
      FormPageDialogComponent,
      FullScreenOverlayLoader,
      ErrorDialog
    },
    props: {
      thumbnail: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      status: {
        type: String,
        required: true
      },
      pageData: {
        type: Object,
        required: true
      },
      resData: {
        type: Object
      },
      resId: {
        type: String
      }
    },
    setup(props) {
      const errorObj = ref({
        isVisible: false,
        errorMsg: ""
      });
      const loaderObj = ref({
        isLoading: false,
        loaderMsg: ""
      });
      const dialogVisible = ref(false);
      const handleClick = async () => {
        try {
          loaderObj.value.isLoading = true;
          loaderObj.value.loaderMsg = "Processing...";
          if (!props.pageData.page_id)
            throw `No page found for ${Helper.getBoldTxt(props.title)}`;
          const _pageRes = await useFormPageStore().getFormPageById(
            props.pageData.page_id,
            true
          );

          if (_pageRes.error) throw _pageRes.error;
          props.pageData.pageObj = _pageRes.data;
          // setting up an existing value to the obj
          Helper.generateFormTemplateResponse(
            [props.pageData],
            props.resData || null
          );
          dialogVisible.value = true;
        } catch (error) {
          errorObj.value.isVisible = true;
          errorObj.value.errorMsg = error;
        } finally {
          loaderObj.value.isLoading = false;
        }
      };

      const onErrorDialogClose = () => {
        errorObj.value.isVisible = false;
        errorObj.value.errorMsg = "";
      };

      return {
        Helper,
        Constants,
        loaderObj,
        errorObj,
        dialogVisible,
        handleClick,
        onErrorDialogClose
      };
    }
  });
</script>
